import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChartResult, EmailResult, GetTicketsForBoardInput, GetTicketsInput, Priority, Result, ResultList, SingleResult, TicketInput, TicketLogResult, TicketResult, TicketStatus, TicketTaskResult, TicketTaskResultForEmployeeBoard } from 'app/models';
import { TicketLevel } from 'app/models/enums/ticket-level.enum';
import { CloseTicketInput } from 'app/models/ticket/close-ticket-input';
import { EmployeeCloseTicketResult } from 'app/models/ticket/employee-close-ticket-result';
import { OpenTicketInput } from 'app/models/ticket/open-ticket-input';
import { OpenTicketResult } from 'app/models/ticket/open-ticket-result';
import { TicketAssignedEmployee } from 'app/models/ticket/ticket-assigned-employee';
import { TicketCustomer } from 'app/models/ticket/ticket-customer';
import { TicketUserModeResult } from 'app/models/ticket/ticket-userMode-result';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  constructor(private httpClient: HttpClient) { }

  public addTicket(ticketInput: TicketInput, token: string): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/AddTicket', ticketInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  // public editTicket(id: number, ticketInput: TicketInput): Promise<Result> {
  //   return this.httpClient.put(Utility.serviceAddress + 'Ticket/EditTicket?id=' + id, ticketInput, Utility.options('dashboardToken'))
  //     .toPromise().then(result => plainToClassFromExist(new Result(), result))
  //     .catch(result => plainToClassFromExist(new Result(), result.error));
  // }

  public deleteTicket(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Ticket/DeleteTicket?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getTickets(getTicketsInput: GetTicketsInput, token: string): Promise<ResultList<TicketResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/GetTickets', getTicketsInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TicketResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TicketResult>(), result.error));
  }

  public getTicketHistory(id: number): Promise<ResultList<TicketLogResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetTicketHistory?ticketId=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TicketLogResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TicketLogResult>(), result.error));
  }

  public getTicket(id: number, token: string): Promise<SingleResult<TicketResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetTicket?id=' + id, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<TicketResult>(TicketResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<TicketResult>(TicketResult), result.error));
  }

  public getATicketForBoard(id: number): Promise<SingleResult<TicketTaskResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetATicketForBoard?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<TicketTaskResult>(TicketTaskResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<TicketTaskResult>(TicketTaskResult), result.error));
  }

  public getTicketsForBoard(getTicketsForBoardInput: GetTicketsForBoardInput): Promise<ResultList<TicketTaskResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/GetTicketsForBoard', getTicketsForBoardInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TicketTaskResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TicketTaskResult>(), result.error));
  }

  public getTicketsForEmployeeBoard(getTicketsForBoardInput: GetTicketsForBoardInput): Promise<ResultList<TicketTaskResultForEmployeeBoard>> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/GetTicketsForEmployeeBoard', getTicketsForBoardInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TicketTaskResultForEmployeeBoard>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TicketTaskResultForEmployeeBoard>(), result.error));
  }

  public updateAssignee(id: number, employeeId: number): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'Ticket/UpdateAssignee?id=' + id, employeeId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public updateTicketStatus(id: number, ticketStatus: TicketStatus): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'Ticket/UpdateTicketStatus?id=' + id, ticketStatus, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public updateTicketLevel(id: number, ticketLevel: TicketLevel): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'Ticket/UpdateTicketLevel?id=' + id, ticketLevel, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public updateStoryPoint(id: number, storyPoint: Number): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'Ticket/UpdateStoryPoint?id=' + id, storyPoint, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public updateTicketType(id: number, ticketTypeId: number): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'Ticket/UpdateTicketType?id=' + id, ticketTypeId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public updateCustomerProjectId(id: number, customerProjectId: number): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'Ticket/UpdateCustomerProjectId?id=' + id, customerProjectId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getTicketsPerProjectReport(closedTickets: boolean | null, token: string): Promise<ResultList<ChartResult>> {
    let address = 'Ticket/GetTicketsPerProjectReport';

    if (closedTickets !== null)
      address = address + '?closedTickets=' + closedTickets;
    return this.httpClient.get(Utility.serviceAddress + address, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ChartResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ChartResult>(), result.error));
  }

  public getOpenTickets(openTicketInput: OpenTicketInput):Promise<ResultList<OpenTicketResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/GetOpenTickets',openTicketInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<OpenTicketResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<OpenTicketResult>(), result.error));
  }

  public getSubTicketList(headerId : Number):Promise<ResultList<Number>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetSubTicketList?headerId=' + headerId, Utility.options('dashboardToken'))
    .toPromise().then(result => plainToClassFromExist(new ResultList<Number>(), result))
    .catch(result => plainToClassFromExist(new ResultList<Number>(), result.error));
  }

  public getClosedTickets(closeTicketInput: CloseTicketInput):Promise<ResultList<OpenTicketResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/GetClosedTickets',closeTicketInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<OpenTicketResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<OpenTicketResult>(), result.error));
  }

  public getEmployeeClosedTickets(closeTicketInput: CloseTicketInput):Promise<ResultList<EmployeeCloseTicketResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/GetEmployeeClosedTickets',closeTicketInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<EmployeeCloseTicketResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<EmployeeCloseTicketResult>(), result.error));
  }

  public getAssignedEmployeeCount():Promise<ResultList<TicketAssignedEmployee>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetAssignedEmployeeCount', Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TicketAssignedEmployee>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TicketAssignedEmployee>(), result.error));
  }

  public getCustomerCount():Promise<ResultList<TicketCustomer>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetCustomerCount', Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TicketCustomer>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TicketCustomer>(), result.error));
  }

  public getTicketStatusReport(token: string): Promise<ResultList<ChartResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetTicketStatusReport', Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ChartResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ChartResult>(), result.error));
  }

  public getTicketCommentUserMode(ticketId: number): Promise<SingleResult<TicketUserModeResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetTicketCommentUserMode?ticketId=' + ticketId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<TicketUserModeResult>(TicketUserModeResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<TicketUserModeResult>(TicketUserModeResult), result.error));
  }

  public getTicketPriorityReport(token: string): Promise<ResultList<ChartResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Ticket/GetTicketPriorityReport', Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ChartResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ChartResult>(), result.error));
  }

  public createTicketsFromEmail(): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/CreateTicketsFromEmail', null, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getTicketsExportToExcel(getTicketsInput: GetTicketsInput): Promise<SingleResult<Uint8Array>> {
    return this.httpClient.post(Utility.serviceAddress + 'Ticket/GetTicketsExportToExcel', getTicketsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<Uint8Array>(Uint8Array), result))
      .catch(result => plainToClassFromExist(new SingleResult<Uint8Array>(Uint8Array), result.error));
  }
}
